
import React from "react";
import { connect } from "react-redux";
import { Trans, withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import Moment from "moment";
import "../App.css";
import $, { data } from "jquery";
import { toast } from "react-toastify";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import {
  getEquipmentMakeModelAndType
} from "../Actions/EquipmentManagementAPI";
import { getZoneList } from "../Actions/VendorManagementAPI";
import { Paginator } from "primereact/paginator";
import { getshipNameList } from "../Actions/UserManageAPI";
import { getPortAndCountry, getAdhocAnalysisData, DownloadExcelReport } from "../Actions/ServiceProviderAPI";
import { getShipOptions } from "../Actions/ContractMgmtAPI";
import axios from "axios";
import API from "../helpers/api";
import { first } from "glamor";
import { getModelsList } from "../Actions/helpersAPI";
import FileSaver from "file-saver";
import moment from "moment";


const PAGESIZE = 25;
// let currentuser = JSON.parse(localStorage.getItem("currentUser"));
class adhocAnalysis extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tableData: [],
      pagination: {
        pageSize: PAGESIZE,
        currentPage: 1,
        totalPages: 7,
        hasNext: true,
        hasPrevious: false
      },
      requestBody: {
        shipId: 0,
        serviceTypeId: 0,
        equipmentId: 0,
        zoneId: 0,
        country: "",
        makeId: 0,
        modelId: 0,
        portId: 0,
        category: "",
        equipmentTypeName: "",
        pageNumber: 1,
        pageSize: PAGESIZE
      },
      autoCompleteValue: {
        shipId: "",
        equipmentId: "",
        country: "",
        serviceTypeId: "",
        category: "",
        equipmentTypeName: "",
        makeId: 0,
        modelId: 0,
        portId: 0,
      },
      zoneListData: [],
      first: 0,
      makeName: ""
    }
  }


  async componentDidMount() {
    const { dispatch,t } = this.props;
    dispatch({ type: "SubBannerTitle", data: "AdHoc Analysis" });
    let data = {
      equipmentId: 0,
      makename: "",
      modelname: "",
      typeId: 0
    };
    this.getEquipmentType();
    dispatch(getShipOptions());
    dispatch(getEquipmentMakeModelAndType(data));
    dispatch(getZoneList());
    // dispatch(getshipNameList());
    dispatch(getPortAndCountry(this.state));
    dispatch({ type: "SubBannerTitle", data: "Adhoc Analysis" });
    dispatch(getModelsList(this.state.makeName));
    this.handleFetchData();
    let _this = this;
    this.keyPressHandler = function (event) {
      var keycode = event.keyCode || event.which;
      // if (
      //   // searchitem.EquipmentId ||
      //   // searchitem.EquipmentType ||
      //   // searchitem.Category ||
      //   // searchitem.ServiceTypeId ||
      //   // searchitem.MakeId ||
      //   // searchitem.ModelId ||
      //   // searchitem.capacity
      //   _this.verifySearchItems()
      // ) {
      if (keycode === 13) {
        if (_this.verifySearchItems()) {
          _this.handleFetchData1(1);
        }
        else {
          toast.success(t('Toast.Success'), {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      }
    }

    $(document).keypress(this.keyPressHandler);

  }

  componentWillUnmount() {

    $(document).off("keypress", this.keyPressHandler);
  }


  getEquipmentType = () => {
    let url = `${API.equipmentLookups}?lookupType=${"contract type"}`;
    axios.get(url).then((response) => {
      let findId = response.data?.filter((item) => item.lookUpName === "FZM")[0]?.lookUpId;
      let url1 = `${API.equipmentLookups}?lookupType=${"plan type"}&parentId=${findId}`;
      axios.get(url1).then((response) => {
        this.setState({ zoneListData: response.data });
      });
    });
  }

  handleClear = () => {
    this.setState({
      requestBody: {
        shipId: 0,
        serviceTypeId: 0,
        equipmentId: 0,
        zoneId: 0,
        makeId: 0,
        modelId: 0,
        portId: 0,
        country: "",
        category: "",
        equipmentTypeName: "",
        pageNumber: 0,
        pageSize: PAGESIZE
      },
      autoCompleteValue: {
        shipId: "",
        equipmentId: "",
        country: "",
        serviceTypeId: ""
      }
    }, () => {
      this.handleFetchData();
    });
  }

  handleFetchData = (_pagination = false) => {
    const { dispatch } = this.props;
    let meta = {
      ...this.state.requestBody,
      pageNumber: _pagination ? this.state.requestBody.pageNumber : 1,
      pageSize: PAGESIZE
    }
    dispatch({ type: "adhocAnalysisiSearch", data: meta });
    dispatch(getAdhocAnalysisData(meta));
  }
  verifySearchItems = () => {
    let requestBody = {
      shipId: 0,
      serviceTypeId: 0,
      equipmentId: 0,
      zoneId: 0,
      country: "",
      makeId: 0,
      modelId: 0,
      portId: 0,
      category: "",
      equipmentTypeName: "",
      pageNumber: 1,
      pageSize: PAGESIZE
    }
    let flag = true;
    var search = this.state.requestBody;
    if (search.shipId == 0 && search.equipmentId == 0 && search.equipmentId == 0 && search.equipmentTypeName == "" && search.category == "" && search.makeId == 0 && search.modelId == 0 && search.serviceTypeId == 0 && search.portId == 0 && search.country == "" && search.zoneId == 0) {
      flag = false;
    }
    return flag;
  }

  handleFetchData1 = (_pagination = false) => {
    const { dispatch, t } = this.props;
    if (this.verifySearchItems()) {

      let meta = {
        ...this.state.requestBody,
        pageNumber: _pagination ? this.state.requestBody.pageNumber : 1,
        pageSize: PAGESIZE
      }
      dispatch({ type: "adhocAnalysisiSearch", data: meta });
      dispatch(getAdhocAnalysisData(meta));
    }
    else {
      toast.success(t('Toast.Success'), {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }
  handleExportData(_pagination = false, contract, both) {
    const { dispatch } = this.props;
    const meta = {
      ...this.state.requestBody,
      pageNumber: _pagination ? this.state.requestBody.pageNumber : 1,
      pageSize: PAGESIZE,
    };

    const URL = `${API.downloadExcel}`;

    axios
      .post(URL, meta, { responseType: "blob" }) // Pass meta as data
      .then((response) => {
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        FileSaver.saveAs(
          blob,
          "Adhoc report " + moment().format("DD MM YYYY LT") + ".xlsx"
        );
      })
      .catch((error) => {
        console.log(error);
      });
  }



  // handleExportData =(_pagination = false) =>{
  //   const { dispatch } = this.props;
  //   let meta = {
  //     ...this.state.requestBody,
  //     pageNumber: _pagination ? this.state.requestBody.pageNumber : 1,
  //     pageSize: PAGESIZE
  //   }
  //   dispatch(DownloadExcelReport(meta));
  // }

  handleAutoComplete(event, value, autocompleteValue, name) {
    
    this.setState({
      requestBody: {
        ...this.state.requestBody,
        [name]: name === "country" ? value || "" : value || 0,
      },
      autoCompleteValue: {
        ...this.state.autoCompleteValue,
        [name]: autocompleteValue,
      }
    });
    if (name === "makeId") {
      this.setState({
        makeName: autocompleteValue?.name || ""
      });
      this.props.dispatch(getModelsList(autocompleteValue?.name || ""));
    }
  };

  handleDropdown = (e) => {
    this.setState({
      requestBody: {
        ...this.state.requestBody,
        [e.target.name]: parseInt(e.target.value),
      }
    });
  }
  formatDate(dateString) {
    const date = new Date(dateString);
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return date.toLocaleDateString('en-GB', options).replace(',', '');
  }

  /* static getDerivedStateFromProps(nextProps, prevState) {
    const { AdhocPagination, AdhocTableData } = nextProps;
    if (AdhocTableData) {
    }
    // adhocpagination need to be setstate
  } */

  render() {
    const {
      zoneListData,
    } = this.state;
    const {
      t,
      EquipmentDropdownList,
      DropdownServiceTypeList,
      DropdownCategoryList,
      DropdownEquipmentTypeList,
      DropdownMakeList,
      ModelList,
      zoneList,
      shipNameList,
      CountryList,
      AdhocTableData,
      AdhocPagination,
      shipListData
    } = this.props;
    return (
      <div className="pt-3">
        <div className="row">
          <div className={"col-lg-12"}>
            <div className="row">
              <div className="col-lg-12">
                <div className="panel-box">
                  <div
                    className="card MM-card-header mb-0"
                    style={{ backgroundColor: "white" }}
                  >
                    <div
                      className="card-body flex"
                      style={{
                        padding: "0rem",
                        backgroundColor: "#1a3464",
                        color: "white",
                      }}
                    >
                      <h5
                        className="card-title ml-2 mt-2 f2"
                        style={{ color: "092a51" }}
                      >
                        {t("AdhocAnalysis.Title")}
                      </h5>
                    </div>
                  </div>
                  <div className="search-filter-box">
                    <div className="row">
                      <div
                        className={"col-lg-4"}
                      >
                        <label className="form-label">{t("content.Shipname")}</label>
                        <br></br>
                        <Autocomplete
                          style={{ marginTop: "-12px" }}
                          noOptionsText={`${t("CommonText.NoOption")}`}
                          size={"small"}
                          value={this.state.autoCompleteValue?.shipId}
                          options={
                            // shipListData ?? []
                            [...new Map((shipListData ?? []).map((item) => [item.lookUpName, item])).values()]
                          }
                          getOptionLabel={(item) => item.lookUpName || ""}
                          filterOptions={(options, state) =>
                            options.filter((option) =>
                              option.lookUpName.toLowerCase().includes(state.inputValue.toLowerCase())
                            )
                          }

                          // onChange={(e, value) => this.onEquipmentChange(e, value?.id, value)}
                          onChange={(event, value) => {
                            this.handleAutoComplete(event, value?.lookUpId, value, "shipId");
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder={t("ContractManagementContent.SelectShipname")}
                              margin="normal"
                            />
                          )}
                        />
                      </div>
                      <div
                        className={"col-lg-4"}
                      >
                        <label className="form-label">{t("ShipEquipmentStatusScreen.Equipment")}</label>
                        <br></br>
                        <Autocomplete
                          style={{ marginTop: "-12px" }}
                          noOptionsText={`${t("CommonText.NoOption")}`}
                          size={"small"}
                          value={this.state.autoCompleteValue?.equipmentId}
                          getOptionLabel={(item) => item?.name || ""}
                          options={EquipmentDropdownList ?? []}
                          // onChange={(e, value) => this.onEquipmentChange(e, value?.id, value)}
                          onChange={(event, value) => {
                            this.handleAutoComplete(event, value?.id, value, "equipmentId");
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder={t("EquipmentManagementScreenContent.SelectEquipment")}
                              margin="normal"
                            />
                          )}
                        />
                      </div>
                      <div
                        className={"col-lg-4"}
                      >
                        <label className="form-label">{t("EquipmentTypeScreen.Title")}</label>
                        <br></br>
                        <Autocomplete
                          style={{ marginTop: "-12px" }}
                          noOptionsText={`${t("CommonText.NoOption")}`}
                          size={"small"}
                          value={this.state.autoCompleteValue?.equipmentTypeName}
                          getOptionLabel={(item) => item || ""}
                          options={DropdownEquipmentTypeList ?? []}
                          // onChange={(e, value) => this.onEquipmentChange(e, value?.id, value)}
                          onChange={(event, value) => {
                            this.handleAutoComplete(event, value, value, "equipmentTypeName");
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder={t("EquipmentManagementScreenContent.SelectEquipmentType")}
                              margin="normal"
                            />
                          )}
                        />
                      </div>
                      <div
                        className={"col-lg-4"}
                      >
                        <label className="form-label">{t("TopPaneContent.Category")}</label>
                        <br></br>
                        <Autocomplete
                          style={{ marginTop: "-12px" }}
                          noOptionsText={`${t("CommonText.NoOption")}`}
                          size={"small"}
                          value={this.state.autoCompleteValue?.category}
                          getOptionLabel={(item) => item || ""}
                          options={DropdownCategoryList ?? []}
                          // onChange={(e, value) => this.onEquipmentChange(e, value?.id, value)}
                          onChange={(event, value) => {
                            this.handleAutoComplete(event, value, value, "category");
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder={t("EquipmentManagementScreenContent.SelectCategory")}
                              margin="normal"
                            />
                          )}
                        />
                      </div>
                      <div className="col-lg-4">
                        <label className="form-label">{t("ShipEquipmentStatusScreen.Make")}</label>
                        <br></br>
                        <Autocomplete
                          style={{ marginTop: "-12px" }}
                          noOptionsText={t("CommonText.NoOption")}
                          size={"small"}
                          value={this.state.autoCompleteValue?.makeId}
                          getOptionLabel={(item) => item.name || ""}
                          options={DropdownMakeList ?? []}
                          onChange={(event, value) => {
                            this.handleAutoComplete(event, value?.id, value, "makeId");
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder={t("MakeAndModelScreen.SelectMake")}
                              margin="normal"
                            />
                          )}
                        />
                      </div>
                      <div className="col-lg-4">
                        <label className="form-label">{t("ShipEquipmentStatusScreen.Model")}</label>
                        <br></br>
                        <Autocomplete
                          style={{ marginTop: "-12px" }}
                          noOptionsText={t("CommonText.NoOption")}
                          size={"small"}
                          value={this.state.autoCompleteValue?.modelId}
                          getOptionLabel={(item) => item.name || ""}
                          options={ModelList ?? []}
                          onChange={(event, value) => {
                            this.handleAutoComplete(event, value?.id, value, "modelId");
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder={t("MakeAndModelScreen.SelectModel")}
                              margin="normal"
                            />
                          )}
                        />
                      </div>
                      <div className="col-lg-4">
                        <label className="form-label">{t("content.Servicetype")}</label>
                        <br></br>
                        <Autocomplete
                          style={{ marginTop: "-12px" }}
                          noOptionsText={t("CommonText.NoOption")}
                          size={"small"}
                          value={this.state.autoCompleteValue?.serviceTypeId}
                          getOptionLabel={(item) => item.name || ""}
                          options={DropdownServiceTypeList ?? []}
                          onChange={(event, value) => {
                            this.handleAutoComplete(event, value?.item, value, "serviceTypeId");
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder={t("EquipmentManagementScreenContent.SelectServiceType")}
                              margin="normal"
                            />
                          )}
                        />
                      </div>
                      <div className="col-lg-4">
                        <label className="form-label">{t("PortManagementScreenContent.Title")}</label>
                        <br></br>
                        <Autocomplete
                          style={{ marginTop: "-12px" }}
                          noOptionsText={t("CommonText.NoOption")}
                          size={"small"}
                          value={this.state.autoCompleteValue?.portId}
                          getOptionLabel={(item) => item.port || ""}
                          options={CountryList ?? []}
                          onChange={(event, value) => {
                            this.handleAutoComplete(event, value?.portId, value, "portId");
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder={t("VendorManagementScreenContent.SelectPort")}
                              margin="normal"
                            />
                          )}
                        />
                      </div>
                      <div className="col-lg-4">
                        <label className="form-label">{t("EquipmentServiceTypes.Country")}</label>
                        <br></br>
                        <Autocomplete
                          style={{ marginTop: "-12.2px" }}
                          noOptionsText={t("CommonText.NoOption")}
                          size={"small"}
                          value={this.state.autoCompleteValue?.country}
                          getOptionLabel={(item) => item.country || ""}
                          options={CountryList ?? []}
                          onChange={(event, value) => {
                            this.handleAutoComplete(event, value?.country, value, "country");
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder={`${t("EquipmentServiceTypes.Country")}`}
                              margin="normal"
                            />
                          )}
                        />
                      </div>
                      <div className="col-lg-4">
                        <label className="form-label">{t("ZoneScreen.Title")}</label>
                        <br></br>
                        <select
                          className="form-control"
                          name="zoneId"
                          value={this.state.requestBody?.zoneId}
                          onChange={e => this.handleDropdown(e)}
                          id="selectZone"
                        >
                          <option value="">{t("VendorManagementScreenContent.SelectZone")}</option>
                          <option>{t("VendorManagementScreenContent.SelectZone")}</option>
                          {/* {zoneList &&
                            zoneList?.map((z) => (
                              <option value={z.id}>
                                {z.value}
                              </option>
                            ))} */}
                          {zoneListData &&
                            zoneListData?.map((z) => (
                              <option value={z.lookUpId}>
                                {z.lookUpName}
                              </option>
                            ))}
                        </select>
                      </div>
                      <div
                        className={"col-lg-12"}
                      >
                        <div
                          className="form-group search-btn-col mt-4"
                          style={{ textAlign: "end" }}
                        >
                          <button
                            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue "
                            type="button"
                            onClick={() => this.handleExportData()}
                          >
                            {/* {" "} */} {t("ComplianceandBudgetScreen.ExportExcel")}
                            {/* {t("content.Search")}{" "} */}
                          </button>
                          <button
                            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue ml-3"
                            type="submit"
                            onClick={() => this.handleFetchData1()}
                          >
                            {" "}
                            {t("content.Search")}{" "}
                          </button>
                          <button
                            className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                            type="button"
                            onClick={() => this.handleClear()}
                          >
                            {" "}
                            {t("content.Clear")}{" "}
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="equip-type-wrapper">
                      <table className="table equipment-report-table border-0">
                        <thead className="">
                          <tr>
                            <th width="9%">{t("content.Shipname")}</th>
                            <th width="15%">{t("ShipEquipmentStatusScreen.Equipment")}</th>
                            <th width="9%">{t("ShipEquipmentStatusScreen.Make")}</th>
                            <th width="9%">{t("ShipEquipmentStatusScreen.Model")}</th>
                            <th width="9%">{t("ShipDetailsScreen.ServiceDate")}</th>
                            <th width="9%">{t("content.Servicetype")}</th>
                            <th width="9%">{t("PortManagementScreenContent.Title")}</th>
                            <th width="9%">{t("EquipmentServiceTypes.Country")}</th>
                            <th width="9%">{t("ZoneScreen.Title")}</th>
                            <th width="4%">{t("ComplianceandBudgetScreen.Qty")}</th>
                            <th width="9%">{t("ServiceBudgetHistory.MMPLAmount")}</th>
                            <th width="9%">{t("ServiceBudgetHistory.VendorPrice")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            AdhocTableData?.data?.length > 0 ? AdhocTableData?.data?.map(x => {
                              return <tr>
                                <td width="9%">{x.shipName && x.shipName}</td>
                                <td width="15%">{x.equipmentName && x.equipmentName}</td>
                                <td width="9%">{x.make && x.make}</td>
                                <td width="9%">{x.model && x.model}</td>
                                <td width="9%">{this.formatDate(x.serviceDate) && this.formatDate(x.serviceDate)}</td>
                                <td width="9%">{x.serviceType && x.serviceType}</td>
                                <td width="9%">{x.portName && x.portName}</td>
                                <td width="9%">{x.countryName && x.countryName}</td>
                                <td width="9%">{x.zone && x.zone}</td>
                                <td width="4%">{x.quantity && x.quantity}</td>
                                <td width="9%">{x.price && x.price}</td>
                                <td width="9%">{x.vendorPrice && x.vendorPrice}</td>
                              </tr>
                            }) :
                              <tr>
                                <td colSpan={11} className="text-center">{t("CommonText.NoItem")}</td>
                              </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                    <Paginator
                      first={(AdhocPagination?.currentPage - 1) * AdhocPagination?.pageSize}
                      // first={this.state.requestBody.pageNumber}
                      // first={this.state.requestBody.pageNumber}
                      rows={this.state.requestBody.pageSize}
                      totalRecords={this.props.AdhocTableData?.pagination?.totalcount}
                      onPageChange={(e) => this.onPaginatorChange(e)}
                    ></Paginator>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
  onPaginatorChange(event) {
    this.setState({
      first: event.first,
      requestBody: {
        ...this.state.requestBody,
        pageNumber: event.page + 1
      }
    }, () => {
      this.handleFetchData(true);
    });
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    EquipmentDropdownList:
      state.MasterScreenReducer.DropdownEquipmentList || [],
    DropdownServiceTypeList: state.MasterScreenReducer.DropdownServiceTypeList,
    zoneList: state.VendorManagementReducer.zoneList,
    // shipNameList: state.UserManagerReducer.shipNameList || [],
    CountryList: state.MasterScreenReducer.CountryList || [],
    AdhocTableData: state.MasterScreenReducer.AdhocTableData || [],
    AdhocPagination: state.MasterScreenReducer.AdhocPagination,
    adhocAnalysisiSearch: state.MasterScreenReducer.adhocAnalysisiSearch,
    shipListData: state.ContractMgmtReducer.shipListData,
    DropdownCategoryList: state.MasterScreenReducer.DropdownCategoryList || [],
    DropdownEquipmentTypeList: state.MasterScreenReducer.DropdownEquipmentTypeList || [],
    DropdownMakeList: state.MasterScreenReducer.DropdownMakeList || [],
    ModelList: state.MasterScreenReducer.ModelList || []
  };
}
export default withTranslation()(withRouter(
  connect(mapStateToProps, mapDispatchToProps)(adhocAnalysis)));